import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    employeeRecomandationName:Yup.string()
     .when('employeeRecomandation', {
        is: employeeRecomandation => employeeRecomandation !== undefined && employeeRecomandation !== false,
        then: Yup.string().required("Angabe ist erforderlich"),
    }),        
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
           <Form.Group className="mb-3" controlId="formEmployeeRecomandation">
                <Form.Check className="checkboxReverse"
                    required={false}
                    name="employeeRecomandation"
                    type="checkbox"
                    onChange={handleChange}
                    label={<span>Ich möchte am Mitarbeiterempfehlungsprogramm teilnehmen:</span>}>
                </Form.Check>
            </Form.Group>

            {!(values.employeeRecomandation===undefined || values.employeeRecomandation===false) && <Form.Group  controlId="formEmployeeRecomandationName">
                    <Form.Label>Mitarbeiterempfehlung durch (Name, Vorname)*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Mitarbeiterempfehlung durch (Name, Vorname) eingeben"
                        type="text"
                        name="employeeRecomandationName"
                        value={values.employeeRecomandationName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.employeeRecomandationName && !errors.employeeRecomandationName}
                        isInvalid={touched.employeeRecomandationName && errors.employeeRecomandationName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.employeeRecomandationName}
                    </Form.Control.Feedback>
                </Form.Group>
            }
        </>
    );
};